export enum ActivityStatusState {
  ONLINE = 'online',
  RECENTLY_OFFLINE = 'recently_offline',
  OFFLINE = 'offline',
}
